// All UI text is Dutch-only (see CLAUDE.md), so string comparisons use the 'nl'
// locale for correct ordering of accented characters and digraphs (e.g. "ij").
export function compareNl(a: string, b: string): number {
  return a.localeCompare(b, 'nl');
}

export function sortByName<T extends { name: string }>(items: T[]): T[];
export function sortByName<T>(items: T[], nameOf: (item: T) => string): T[];
export function sortByName<T>(items: T[], nameOf?: (item: T) => string): T[] {
  const getName = nameOf ?? ((item: T) => (item as unknown as { name: string }).name);
  return [...items].sort((a, b) => compareNl(getName(a), getName(b)));
}
